<template>
    <div id="edit_station" class="ui segment">
        <h1 class="ui header">{{ station.name }}</h1>
        <div v-if="is_initialized">
            <div class="ui form">
                <div class="field">
                    <label>{{ $t('models.attributes.stations.name') }}</label>
                    <input type="text" v-model="station.name">
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.stations.code') }}</label>
                    <input type="text" v-model="station.code">
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.stations.address') }}</label>
                    <input type="text" v-model="station.address">
                </div>
                <div class="field">
                    <label>{{ $t('models.attributes.stations.phone') }}</label>
                    <input type="text" v-model="station.phone">
                </div>
                <div class="field" v-if="!is_google_map_activated"
                    @click="is_google_map_activated = true"
                >
                    <label class="pointer">
                        {{ $t('ui.general.edit') }}
                        {{ $t('models.attributes.stations.position') }}
                    </label>
                </div>
                <div class="field" v-else>
                    <label>
                        {{ $t('models.attributes.stations.position') }}
                        　　<span
                            class="ui red pointer" @click="is_google_map_refresh = !is_google_map_refresh">
                            <i class="icon refresh"></i>
                            [Google map]
                        </span>
                    </label>
                    <input type="text" v-model="station.position">

                    <GoogleMapsDrawingPolygon v-if="is_initialized"
                        class="field"
                        :positions="google_maps_options.positions"
                        :center_position="center_position"
                        :refresh="is_google_map_refresh"
                        :zoom="google_maps_options.zoom"
                        :channel="google_maps_options.channel"
                    >
                    </GoogleMapsDrawingPolygon>
                </div>

                <div class="field">
                    <label>{{ $t('models.attributes.stations.note') }} </label>
                    <textarea type="text" v-model="station.note"></textarea>
                </div>
                <button class="ui basic fluid positive button" @click.prevent="update_station">{{ $t('ui.general.update') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import GoogleMapsDrawingPolygon from "@toolbox/google_maps/drawing_polygon.vue"

export default {
    name: "EditStation",
    props: {
    },
    data() {
        return {
            is_initialized: false,
            is_processing: false,
            station: {},
            errors: [],
            is_google_map_activated: false,
            is_google_map_refresh: false,
            google_maps_options: {
                channel: 'google_maps_channel_new_position',
                positions: [],
                zoom: 12,
            }
        }
    },
    created() {
        this.init()
    },
    mounted() {
    },
    watch: {
    },
    computed: {
        center_position() {
            try {
                this.google_maps_options.positions = $.parseJSON(this.station.position) || []
            } catch (e) {
                this.google_maps_options.positions = []
            }

            var positions = this.google_maps_options.positions
            if (positions.length > 2) {
                var first_position = positions[0]
                var farthest_position = positions[Math.floor(positions.length/2)]
                return [
                    (first_position[0] + farthest_position[0])/2,
                    (first_position[1] + farthest_position[1])/2
                ]
            } else {
                switch (this.$store.state.language) {
                    case 'zh-TW':
                        this.google_maps_options.zoom = 8.46
                        return [23.911035, 121.058502]
                        break
                    case 'zh-CN':
                        this.google_maps_options.zoom = 6
                        return [30.683674, 113.436786]
                        break
                    case 'en-US':
                        this.google_maps_options.zoom = 5
                        return [39.766216, -99.734738]
                        break
                    case 'vi-VN':
                        this.google_maps_options.zoom = 8.2
                        return [10.814402, 106.633343]
                        break
                    case 'ja-JP':
                        this.google_maps_options.zoom = 8
                        return [35.9178459, 138.050514]
                        break
                    case 'ko-KR':
                        this.google_maps_options.zoom = 8
                        return [36.9729748,127.4632146]
                        break
                    case 'es-ES':
                        this.google_maps_options.zoom = 7
                        return [40.416685, -3.703634]
                        break
                    case 'de-DE':
                        this.google_maps_options.zoom = 7
                        return [50.9377065, 9.5896637]
                        break
                    case 'km-KH':
                        this.google_maps_options.zoom = 8
                        return [12.5106503,104.1691429]
                        break

                    default:
                        this.google_maps_options.zoom = 8.46
                        return [23.911035, 121.058502]
                }
            }
        },
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.is_initialized = false
                this.is_processing = false
                this.station = {}
                this.errors = []
                resolve()
            })
            await this.fetch_station()
            await this.set_google_maps_channel()
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })
        },
        fetch_station() {
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_station).parse(
                {
                    "station_identity": this.$route.params.station_identity
                },
                ""
            )
            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then((response) => {
                    this.station = response.data.station
                })
                .catch(error => {
                    // this.$noty.error("抓取站點失敗")
                    this.$noty.error(
                        this.$t('ui.notifications.error.fetch__name', {
                            name: this.$t('models.stations'),
                            reason: ': ' + error
                        })
                    )
                })
        },
        set_google_maps_channel() {
            this.$bus.$off(this.google_maps_options.channel)
            this.$bus.$on(this.google_maps_options.channel, (array = null) => {
                var to_string = array.map(x => "[" + x + "]").toString()
                this.station.position = "[" + to_string + "]"
            })
        },
        update_station() {
            this.is_processing = true
            this.errors = []
            var params = _.cloneDeep(this.station)
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_station_update).parse(
                {
                    "station_identity": this.$route.params.station_identity,
                },
                ""
            )

            axios.post(url, params, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then((response) => {
                    if (response.data.status == "success") {
                        // this.$noty.success("站點更新成功")
                        this.$noty.success(
                            this.$t('ui.notifications.success.update__name', {
                                name: this.$t('models.stations')
                            })
                        )
                        this.$store.dispatch('provider/fetch_stations')
                        this.$router.push({ name: "stations" })
                    } else {
                        // this.$noty.error("站點更新失敗")
                        this.$noty.error(
                            this.$t('ui.notifications.error.update__name', {
                                name: this.$t('models.stations'),
                                reason: ': ' + response.data.errors
                            })
                        )
                        this.errors = response.data.errors
                    }
                })
                .catch(error => {
                    console.log(error)
                    if (!error.response) {
                        // Network Error
                        this.$noty.error(
                            this.$t('ui.general.network_abnormality')+": "+
                            this.$t('ui.general.server_offline')
                        )
                    } else {
                        this.$noty.error(this.$t('ui.general.network_abnormality')+': ' + error.response.status + error.response.data)
                    }
                })
                this.is_processing = false
        },
    },
    components: {
        GoogleMapsDrawingPolygon
    }
}
</script>

<style scoped>
</style>
